import authRepository from './authRepository';
import userRepository from './userRepository';
import profileRepository from './profileRepository';
import accessorialRepository from './accessorialRepository';
import companyRepository from './companyRepository';
import departmentRepository from './departmentRepository';
import carriersRepository from './carriersRepository';
import cannedResponsesRepository from './cannedResponsesRepository';
import blackListRepository from './blackListRepository';
import rulesRepository from './rulesRepository';
import cspRepository from './cspRepository';
import accountsRepository from './accountsRepository';

const repositories = {
  auth: authRepository,
  users: userRepository,
  profiles: profileRepository,
  accessorials: accessorialRepository,
  companies: companyRepository,
  departments: departmentRepository,
  carriers: carriersRepository,
  cannedResponses: cannedResponsesRepository,
  blackList: blackListRepository,
  rulesAdmin: rulesRepository,
  customerSpecificPricing: cspRepository,
  accounts: accountsRepository,
};

export default {
  service: (name) => repositories[name],
};
